<template>
    <section class="gds" v-loading="loading">
        
        <el-alert
            v-if="error"
            title="Ha ocurrido un error"
            type="error"
            :closable="false"
            center>
        </el-alert>
        <template v-else-if="data">

            <table>
                <thead>
                    <tr>
                        <th>Documento</th>
                        <th v-for="th in data.thead" :key="th.id">
                            <div>
                                <div class="celda-vertical">
                                    <p>{{ th.name }}</p>
                                </div>
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="tb in data.tbody" :key="tb.id">
                        <td>
                            <p>{{ tb.name }}</p>
                        </td>
                        <td 
                        v-for="(th, indiceTipo) in data.thead" 
                        :key="th.id" 
                        :class="[{active: columnaResaltada && columnaResaltada == indiceTipo}]" 
                        @mouseover="columnaResaltada = indiceTipo" 
                        @mouseout="columnaResaltada = null">
                            <ul class="switch">
                                <li 
                                    @click="setStatus(th.id, 1, tb)"
                                    :class="['switch-success', {active: obtenerStatus(th.id, tb) == 1 }]">
                                    <p>Estado 1</p>
                                </li>

                                <li 
                                    @click="setStatus(th.id, 2, tb)" 
                                    :class="['switch-warning', {active: obtenerStatus(th.id, tb) == 2 }]">
                                    <p>Estado 2</p>
                                </li>

                                <li 
                                    @click="setStatus(th.id, 3, tb)" 
                                    :class="['switch-error', {active: obtenerStatus(th.id, tb) == 3 }]">
                                    <p>Estado 3</p>
                                </li>
                            </ul>
                            
                        </td>
                    </tr>
                </tbody>
            </table>

        </template>

    </section>
</template>

<script>
    import {
        getUrl
    } from '@/helpers/api'

	export default {
        name: 'GDS',
        props: {
            id: String,
            ficha: Object,
            entidad: String,
            porlet: Object,
            currentAction: Object,
            reload: {
                type: Boolean,
                required: false,
                default: () => false
            },
            autoReload: {
                type: Boolean,
                required: false,
                default: () => false
            },
            visibleReload: {
                type: Boolean,
                required: false,
                default: () => false
            }
        },
		data () {
			return {
                loading: false,
                error: null,
                data: null,
                columnaResaltada: null,
            }
        },
        mounted() {

            this.getData()

            this.$emit('created')
        },
        methods: {
            async getData() {

                if (this.loading) return
                
                this.error = false
                
                try {
                    
                    // Generar tipos y documentos
                    var resp = {
                        thead: [
                            "cerrajeros", "marmolistas", "constructores", "electricistas", "fontaneros",
                            "pintores", "carpinteros", "albañiles", "jardineros", "plomeros",
                            "arquitectos", "diseñadores", "instaladores de sistemas de seguridad", 
                            "limpiadores", "técnicos de climatización", "reparadores de electrodomésticos", 
                            "técnicos de redes", "asistentes administrativos", "mecánicos de automóviles", 
                            "técnicos de audio y video", "ingenieros civiles", "expertos en energías renovables",
                            "técnicos de telecomunicaciones", "dibujantes técnicos", "peritos judiciales", 
                            "analistas de sistemas", "analistas de datos", "fotógrafos", "técnicos de iluminación",
                            "técnicos en robótica", "paisajistas", "técnicos de mantenimiento", 
                            "técnicos en seguridad informática", "geólogos", "técnicos en control de calidad", 
                            "programadores", "técnicos de sonido", "técnicos de laboratorio", 
                            "especialistas en marketing digital", "técnicos en topografía", "técnicos en logística", 
                            "técnicos en impresión 3D", "técnicos en drones", "diseñadores de interiores",
                            "expertos en inteligencia artificial", "analistas financieros", "técnicos en emergencias médicas",
                            "técnicos en energía nuclear", "técnicos en nanotecnología", "analistas de ciberseguridad"
                        ],
                        tbody: [
                            "Certificado", "Contrato", "Factura", "Informe", "Licencia",
                            "Plan de trabajo", "Presupuesto", "Recibo", "Solicitud", "Contraseña",
                            "Manual de usuario", "Política de privacidad", "Memorando", "Garantía",
                            "Declaración jurada", "Permiso", "Protocolo", "Acta", "Reglamento",
                            "Memoria descriptiva", "Autorización", "Hoja de vida", "Certificación",
                            "Acta notarial", "Memorándum de entendimiento", "Acuerdo", "Cédula de identidad",
                            "Informe técnico", "Certificado médico", "Patente", "Informe financiero",
                            "Permiso de construcción", "Permiso de trabajo", "Acta de nacimiento", "Testamento",
                            "Póliza de seguro", "Tarjeta de crédito", "Licencia de conducir", "Pasaporte",
                            "Declaración de impuestos", "Contraseña segura", "Receta médica", "Diploma",
                            "Tarjeta de embarque", "Visa", "Reglamento interno", "Certificado de estudios",
                            "Manual de procedimientos", "Acta de matrimonio", "Poder notarial"
                        ]
                    }

                    // Cabecera (columnas)
                    let thead = []
                    if (resp.thead) {
                        thead = resp.thead.map((value, indice) => {
                            return {
                                id: indice,
                                name: value
                            }
                        })
                    }

                    // Filas
                    let tbody = []
                    if (resp.tbody) {
                        for(let i = 0; i < 10; i++) {
                            tbody.push({
                                thead: resp.thead.map((value, indice) => {
                                    return {
                                        indice,
                                        status: Math.ceil(Math.random() * 3)
                                    }
                                }),
                                name: resp.tbody[Math.floor(Math.random() * 51) + 1]
                            })
                        }
                    }
                    
                    this.data = { thead, tbody }

                } catch(err) {

                    console.log(err)

                    this.error = true
                }
            },
            obtenerStatus(tipoId, tbody) {
                const res = tbody.thead.find(f => f.indice === tipoId);
                return res ? res.status : 'No disponible';
            },
            setStatus(tipoId, currentStatus, tbody) {

                let status = currentStatus == 3 ? 1 : currentStatus + 1
                let tipoEnDocumento = tbody.thead.find(f => f.indice === tipoId)

                try {
                    
                    tipoEnDocumento.status = status

                } catch (e) {

                    tipoEnDocumento.status = currentStatus

                    console.log('error ', e)
                }
            }
        }
	}
</script>

<style lang="scss">
section.gds {
    overflow: auto;
    height: 100vh;
    background-color: #edeff3;
    display: flex;
    flex-flow: column;
    table {
        border-collapse: collapse;
        width: 100%;
        background-color: white;
        thead {
            position: sticky;
            top: 0;
            background-color: white;
            z-index: 1;
            th {
                height: 150px;
                max-width: 150px;
                position: relative;
                padding: 0px;
                > div {
                    width: -webkit-fill-available;
                    height: -webkit-fill-available;
                    border-bottom: 1px solid #dddddd;
                    .celda-vertical {
                        width: 150px;
                        position: absolute;
                        transform: translate(-50%, 50%) rotate(270deg);
                        left: 50%;
                        bottom: 50%;
                        p {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            text-align: left;
                            padding: 10px;
                            max-height: 28px;
                        }
                    }
                }
            }
        }

        tbody tr td:first-child {
            position: sticky;
            left: 0;
            background-color: white;
            padding: 0px;
            display: flex;
            flex-flow: column;
            min-height: 65px;
            p {
                border-right: 1px solid #dddddd;
                margin: 0;
                height: revert;
                flex-grow: 1;
                display: flex;
                min-height: 0;
                width: 100%;
                align-items: center;
                justify-content: center;
            }
        }
        tr {
            &:hover {
                background-color: #f3f3f3;
            }
        }
        th, td {
            border: 1px solid #ddd;
            padding: 8px;
            font-size: 0.8rem;
            text-transform: capitalize;
            text-align: center;
            th {
                background-color: #f2f2f2;
            }
            &.active {
                background-color: #efefef;
            }
        }
        td:hover {
            background-color: #e4e4e4!important;
        }
    }
}

/* Componente switch */
ul.switch {
    list-style: none;
    padding: 0;
    margin: 0;
    width: 100%;
    height: 50px;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    li {
        margin: 2px;
        border-radius: 4px;
        cursor: pointer;
        display: none;
        align-items: center;
        padding: 2px 10px;
        color: white;
        min-height: 15px;

        &.switch-success {
            &.active {
                background-color: #67C23A;
                display: block;
            }
        }
        &.switch-warning {
            &.active {
                background-color: #E6A23C;
                display: block;
            }
        }
        &.switch-error {
            &.active {
                background-color: #F56C6C;
                display: block;
            }
        }

        p {
            margin: 0px;
            display: none;
        }
    }
}
</style>